import messageTypes from '../../../enums/messageTypes'

const showAppMessage = (message, messageType = messageTypes.ERROR) => ({
	message,
	messageType,
	showSnackbar: true
})

export default showAppMessage



// WEBPACK FOOTER //
// ./src/redux/reducers/utilities/showAppMessage.js